import { ViewModel, View, ObservableArray } from "binder"
import { ShiftAssignmentManipulationView } from "./shiftAssignmentManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { IShiftAssignment } from "./IShiftAssignment";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { WorkingShiftSelectorViewModel } from "./workingShiftSelector-viewModel";
import { WeekSelectorMultiSelectorViewModel, WeekSelectorViewModel } from "./weekSelector-viewModel";
import moment from "moment";

export class ShiftAssignmentManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تخصیص شیفت به خطوط تولید';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.shiftAssignments = ObservableArray.create<ShiftAssignment>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new ShiftAssignmentManipulationView();
    }
    public getTypeId(): string {
        return "VM-5165D51A-5FC5-413F-A90E-C7349EF87657"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean; s
    public set shiftAssignments(v: ObservableArray<ShiftAssignment>) { this._shiftAssignments = v; } public get shiftAssignments(): ObservableArray<ShiftAssignment> { return this._shiftAssignments; } private _shiftAssignments: ObservableArray<ShiftAssignment>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ProductLineServices/ListAllProductLines', {
                FilteringInformation: filteringInformation
            });
            this.shiftAssignments.update(...result.ProductLines.map((x, i) => {
                let s = new ShiftAssignment(this);
                s.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                s.productLineId = x.Id;
                s.productLineName = x.Name;
                return s;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async showDetail(shiftAssignment: IShiftAssignment) {
        let shiftAssignmentStructure = new ShiftAssignmentStructureViewModel(this);
        shiftAssignmentStructure.loadById(shiftAssignment.productLineId);
        shiftAssignment.cloneTo(shiftAssignmentStructure);
        this.requestShowingPopup(shiftAssignmentStructure);
    }
}

export class ShiftAssignment extends ViewModel implements IShiftAssignment {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ShiftAssignmentManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    setWorkingShiftId(id: string) {
        throw new Error("Method not implemented.");
    }
    getWorkingShiftId(): string {
        throw new Error("Method not implemented.");
    }
    setWorkingShiftName(name: string) {
        throw new Error("Method not implemented.");
    }
    getWorkingShiftName(): string {
        throw new Error("Method not implemented.");
    }
    setDayOfWeekId(id: string) {
        throw new Error("Method not implemented.");
    }
    getDayOfWeekId(): string {
        throw new Error("Method not implemented.");
    }
    setDayOfWeekIds(value: string[]) {
        throw new Error("Method not implemented.");
    }
    getDayOfWeekIds(): string[] {
        throw new Error("Method not implemented.");
    }
    setDayOfWeekName(name: string) {
        throw new Error("Method not implemented.");
    }
    getDayOfWeekName(): string {
        throw new Error("Method not implemented.");
    }

    private _typedParent: ShiftAssignmentManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set productLineId(v: string) { this._productLineId = v; } public get productLineId(): string { return this._productLineId; } private _productLineId: string;
    public set productLineName(v: string) { this._productLineName = v; } public get productLineName(): string { return this._productLineName; } private _productLineName: string;
    public set startDate(v: moment.Moment) { this._startDate = v; } public get startDate(): moment.Moment { return this._startDate; } private _startDate: moment.Moment;
    public set endDate(v: moment.Moment) { this._endDate = v; } public get endDate(): moment.Moment { return this._endDate; } private _endDate: moment.Moment;

    async cloneTo(shiftAssignment: IShiftAssignment) {
        shiftAssignment.id = this.id;
        shiftAssignment.productLineId = this.productLineId;
        shiftAssignment.productLineName = this.productLineName;
    }

    async showDetail() {
        await this._typedParent.showDetail(this);
    }
}

export class ShiftAssignmentStructureViewModel extends ViewModel {
    public getTypeId(): string { return 'shiftassignment-structure'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.singleShiftAssignments = ObservableArray.create<SingleShiftAssignment>();
        this.workingShiftSelector = new WorkingShiftSelectorViewModel(this);
        this.dayOfWeekSelector = new WeekSelectorViewModel(this);
        this.dayOfWeekMultiSelector = new WeekSelectorMultiSelectorViewModel(this);
    }

    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set productLineId(v: string) { this._productLineId = v; } public get productLineId(): string { return this._productLineId; } private _productLineId: string;
    public set productLineName(v: string) { this._productLineName = v; } public get productLineName(): string { return this._productLineName; } private _productLineName: string;
    public set startDate(v: moment.Moment) { this._startDate = v; } public get startDate(): moment.Moment { return this._startDate; } private _startDate: moment.Moment;
    public set endDate(v: moment.Moment) { this._endDate = v; } public get endDate(): moment.Moment { return this._endDate; } private _endDate: moment.Moment;
    public set singleShiftAssignments(v: ObservableArray<SingleShiftAssignment>) { this._singleShiftAssignments = v; } public get singleShiftAssignments(): ObservableArray<SingleShiftAssignment> { return this._singleShiftAssignments; } private _singleShiftAssignments: ObservableArray<SingleShiftAssignment>;
    public set workingShiftId(v: string) { this._workingShiftId = v; } public get workingShiftId(): string { return this._workingShiftId; } private _workingShiftId: string;
    public set workingShiftName(v: string) { this._workingShiftName = v; } public get workingShiftName(): string { return this._workingShiftName; } private _workingShiftName: string;
    public set workingShiftSelector(v: WorkingShiftSelectorViewModel) { this._workingShiftSelector = v; } public get workingShiftSelector(): WorkingShiftSelectorViewModel { return this._workingShiftSelector; } private _workingShiftSelector: WorkingShiftSelectorViewModel;
    public set dayOfWeekId(v: string) { this._dayOfWeekId = v; } public get dayOfWeekId(): string { return this._dayOfWeekId; } private _dayOfWeekId: string;
    public set dayOfWeekName(v: string) { this._dayOfWeekName = v; } public get dayOfWeekName(): string { return this._dayOfWeekName; } private _dayOfWeekName: string;
    public set dayOfWeekSelector(v: WeekSelectorViewModel) { this._dayOfWeekSelector = v; } public get dayOfWeekSelector(): WeekSelectorViewModel { return this._dayOfWeekSelector; } private _dayOfWeekSelector: WeekSelectorViewModel;
    public set dayOfWeekMultiSelector(v: WeekSelectorMultiSelectorViewModel) { this._dayOfWeekMultiSelector = v; } public get dayOfWeekMultiSelector(): WeekSelectorMultiSelectorViewModel { return this._dayOfWeekMultiSelector; } private _dayOfWeekMultiSelector: WeekSelectorMultiSelectorViewModel;
    public set isUpdate(v: boolean) { this._isUpdate = v; } public get isUpdate(): boolean { return this._isUpdate; } private _isUpdate: boolean;

    setWorkingShiftId(id: string) {
        this.workingShiftSelector.selectById(id);
    }
    getWorkingShiftId(): string {
        return this.workingShiftSelector.selectedItem?.id;
    }
    clearWorkingShift(): string {
        return this.workingShiftSelector.selectedItem = null;
    }

    setWorkingShiftName(name: string) {
        this.workingShiftName = name;
    }
    getWorkingShiftName(): string {
        return this.workingShiftName;
    }

    setDayOfWeekId(id: string) {
        this.dayOfWeekSelector.selectById(id);
    }
    getDayOfWeekId(): string {
        return this.dayOfWeekSelector.selectedItem?.id;
    }

    setDayOfWeekIds(value: string[]) {
        this.dayOfWeekMultiSelector.selectById(value);
    }
    getDayOfWeekIds(): string[] {
        return this.dayOfWeekMultiSelector.selectedItems.map(x => x.id);
    }
    clearDayOfWeek() {
        this.dayOfWeekSelector.refresh();
    }

    setDayOfWeekName(name: string) {
        this.dayOfWeekName = name;
    }
    getDayOfWeekName(): string {
        return this.dayOfWeekName;
    }

    async loadById(id: string) {
        try {
            let result = await ServerConnection.callServer('/Complex/WorkingShiftServices/GetAllWorkingShiftsOfProductLine', {
                ProductLineId: id
            });
            this.singleShiftAssignments.update(...result.WorkingShifts.map((x, i) => {
                let s = new SingleShiftAssignment(this);
                s.index = i + 1;
                s.id = x.ShiftAssignmentId;
                s.workingShiftId = x.WorkingShiftId;
                let start = `${Math.floor(x.StartTime / 60)}:${x.StartTime % 60}`;
                let end = `${Math.floor(x.EndTime / 60)}:${x.EndTime % 60}`;
                s.workingShiftName = `${x.Name} (${moment(start, 'HH:mm').format('HH:mm')} تا ${moment(end, 'HH:mm').format('HH:mm')})`;
                s.startDate = x.StartDate;
                s.endDate = x.EndDate;
                s.dayOfWeekId = x.WeekDay;
                switch (x.WeekDay) {
                    case 1:
                        s.dayOfWeekName = "شنبه";
                        break;
                    case 2:
                        s.dayOfWeekName = "یک‌شنبه";
                        break;
                    case 3:
                        s.dayOfWeekName = "دوشنبه";
                        break;
                    case 4:
                        s.dayOfWeekName = "سه‌شنبه";
                        break;
                    case 5:
                        s.dayOfWeekName = "چهارشنبه";
                        break;
                    case 6:
                        s.dayOfWeekName = "پنج‌شنبه";
                        break;
                    case 7:
                        s.dayOfWeekName = "جمعه";
                        break;
                }
                return s;
            }));
        } catch (ex) {
            console.log(ex);
        }
    }

    closePopup(result: any) {

    }

    back() {
        this.closePopup(null);
    }

    async cloneTo(shiftAssignment: IShiftAssignment) {
        shiftAssignment.id = this.id;
        shiftAssignment.productLineId = this.productLineId;
        shiftAssignment.productLineName = this.productLineName;
        shiftAssignment.startDate = this.startDate;
        shiftAssignment.endDate = this.endDate;
        shiftAssignment.setWorkingShiftId(this.getWorkingShiftId());
        shiftAssignment.setWorkingShiftName(this.getWorkingShiftName());
        shiftAssignment.setDayOfWeekId(this.getDayOfWeekId());
        shiftAssignment.setDayOfWeekIds(this.getDayOfWeekIds());
        shiftAssignment.setDayOfWeekName(this.getDayOfWeekName());
    }

    async addWorkShifts() {
        let dayOfWeeks = this.getDayOfWeekIds();
        dayOfWeeks.forEach(day => {
            this.updateWorkShifts(day);
        })
    }

    async updateWorkShifts(dayOfWeekId: string) {
        let newShiftAssignment = new SingleShiftAssignment(this);
        newShiftAssignment.startDate = this.startDate;
        newShiftAssignment.endDate = this.endDate;
        newShiftAssignment.dayOfWeekId = dayOfWeekId;
        newShiftAssignment.workingShiftId = this.getWorkingShiftId();
        this.singleShiftAssignments.push(newShiftAssignment);
    }

    async callServer() {
        let result = await ServerConnection.callServer('/Complex/WorkingShiftServices/SyncProductLineWorkingShifts', {
            ProductLineId: this.productLineId,
            WorkingShiftData: this.singleShiftAssignments.map(q => {
                return {
                    StartDate: q.startDate,
                    EndDate: q.endDate,
                    WeekDay: q.dayOfWeekId,
                    WorkingShiftId: q.workingShiftId,
                    ShiftAssignmentId: q.id
                }
            })
        });
        if (result.IsSuccessful == true) {
            this.startDate = null;
            this.endDate = null;
            this.clearWorkingShift();
            this.clearDayOfWeek();
            this.isUpdate = false;
            await this.messageBoxConfirmSuccess('تخصیص شیفت با موفقیت انجام شد.', 'ثبت موفق');
        }
        else {
            await this.messageBoxConfirmWarning("خطا در عملیات", "خطا در عملیات");
        }
    }

    async save(): Promise<void> {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در تخصیص شیفت');
            return;
        } else {
            try {
                await this.addWorkShifts();
                await this.callServer();
                await this.loadById(this.productLineId);
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در تخصیص شیفت', 'خطا در عملیات');
                console.log(ex);
            }
        }
    }

    async edit(shiftAssignment: IShiftAssignment) {
        await shiftAssignment.cloneTo(this);
        this.isUpdate = true;
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.getWorkingShiftId())) {
            result.push('نام شیفت مشخص نشده است.');
        }
        // if (this.singleShiftAssignments.filter(x => x.workingShiftSelector.selectedItem == null).length > 0) {
        //     result.push('روزهای هفته مشخص نشده است.');
        // }
        if (this.startDate == null) {
            result.push('تاریخ شروع مشخص نشده است.');
        }
        if (this.endDate == null) {
            result.push('تاریخ پایان مشخص نشده است.');
        }
        if (this.endDate <= this.startDate) {
            result.push('تاریخ پایان کوچکتر از تاریخ شروع است.');
        }
        return result;
    }
}

export class SingleShiftAssignment extends ViewModel implements IShiftAssignment {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ShiftAssignmentStructureViewModel) {
        super(parent);
        this._typedParent = parent;
        this.workingShiftSelector = new WorkingShiftSelectorViewModel(this);
        this.dayOfWeekSelector = new WeekSelectorViewModel(this);
        this.dayOfWeekMultiSelector = new WeekSelectorMultiSelectorViewModel(this);
    }

    private _typedParent: ShiftAssignmentStructureViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set productLineId(v: string) { this._productLineId = v; } public get productLineId(): string { return this._productLineId; } private _productLineId: string;
    public set productLineName(v: string) { this._productLineName = v; } public get productLineName(): string { return this._productLineName; } private _productLineName: string;
    public set startDate(v: moment.Moment) { this._startDate = v; } public get startDate(): moment.Moment { return this._startDate; } private _startDate: moment.Moment;
    public set endDate(v: moment.Moment) { this._endDate = v; } public get endDate(): moment.Moment { return this._endDate; } private _endDate: moment.Moment;
    public set workingShiftId(v: string) { this._workingShiftId = v; } public get workingShiftId(): string { return this._workingShiftId; } private _workingShiftId: string;
    public set workingShiftName(v: string) { this._workingShiftName = v; } public get workingShiftName(): string { return this._workingShiftName; } private _workingShiftName: string;
    public set workingShiftSelector(v: WorkingShiftSelectorViewModel) { this._workingShiftSelector = v; } public get workingShiftSelector(): WorkingShiftSelectorViewModel { return this._workingShiftSelector; } private _workingShiftSelector: WorkingShiftSelectorViewModel;
    public set dayOfWeekId(v: string) { this._dayOfWeekId = v; } public get dayOfWeekId(): string { return this._dayOfWeekId; } private _dayOfWeekId: string;
    public set dayOfWeekName(v: string) { this._dayOfWeekName = v; } public get dayOfWeekName(): string { return this._dayOfWeekName; } private _dayOfWeekName: string;
    public set dayOfWeekSelector(v: WeekSelectorViewModel) { this._dayOfWeekSelector = v; } public get dayOfWeekSelector(): WeekSelectorViewModel { return this._dayOfWeekSelector; } private _dayOfWeekSelector: WeekSelectorViewModel;
    public set dayOfWeekMultiSelector(v: WeekSelectorMultiSelectorViewModel) { this._dayOfWeekMultiSelector = v; } public get dayOfWeekMultiSelector(): WeekSelectorMultiSelectorViewModel { return this._dayOfWeekMultiSelector; } private _dayOfWeekMultiSelector: WeekSelectorMultiSelectorViewModel;
    public set isUpdate(v: boolean) { this._isUpdate = v; } public get isUpdate(): boolean { return this._isUpdate; } private _isUpdate: boolean;

    setWorkingShiftId(id: string) {
        this.workingShiftId = id;
    }
    getWorkingShiftId(): string {
        return this.workingShiftId;
    }

    setWorkingShiftName(name: string) {
        this.workingShiftName = name;
    }
    getWorkingShiftName(): string {
        return this.workingShiftName;
    }

    setDayOfWeekId(id: string) {
        this.dayOfWeekSelector.selectById(id);
    }
    getDayOfWeekId(): string {
        return this.dayOfWeekSelector.selectedItem?.id;
    }

    setDayOfWeekIds(value: string[]) {
        this.dayOfWeekMultiSelector.selectById(value);
    }
    getDayOfWeekIds(): string[] {
        return this.dayOfWeekMultiSelector.selectedItems.map(x => x.id);
    }

    setDayOfWeekName(name: string) {
        this.dayOfWeekName = name;
    }
    getDayOfWeekName(): string {
        return this.dayOfWeekName;
    }

    async cloneTo(shiftAssignment: IShiftAssignment) {
        shiftAssignment.id = this.id;
        // shiftAssignment.productLineId = this.productLineId;
        // shiftAssignment.productLineName = this.productLineName;
        shiftAssignment.startDate = this.startDate;
        shiftAssignment.endDate = this.endDate;
        shiftAssignment.setWorkingShiftId(this.getWorkingShiftId());
        shiftAssignment.setWorkingShiftName(this.getWorkingShiftName());
        shiftAssignment.setDayOfWeekId(this.dayOfWeekId);
        shiftAssignment.setDayOfWeekIds(this.getDayOfWeekIds());
        shiftAssignment.setDayOfWeekName(this.getDayOfWeekName());
    }

    async edit() {
        this._typedParent.edit(this);
    }
}
